// Scroll the app back to the top. On desktop the window scrolls the page; on
// mobile the page scrolls inside main.mobile-main (overflow-y auto), where
// window.scrollTo is a silent no-op — always reset both.
export function scrollAppToTop(smooth = false) {
  const behavior = smooth ? ('smooth' as const) : ('auto' as const);
  window.scrollTo({ top: 0, behavior });
  document.querySelector('main.mobile-main')?.scrollTo({ top: 0, behavior });
}
